import { useFeatureValue } from '@growthbook/growthbook-react';
import { FEATURE_FLAG } from '../constants/featureFlags';

const DEFAULT_KYC_MAX_ATTEMPTS = 5;

const useKycAttempts = (kycAttempts?: number | null) => {
  const attempts = kycAttempts ?? 0;
  const maxAttempts = useFeatureValue<number>(FEATURE_FLAG.KYC_MAX_ATTEMPTS, DEFAULT_KYC_MAX_ATTEMPTS);

  return {
    attempts,
    hasReachedLimit: attempts >= maxAttempts,
    maxAttempts,
  };
};

export default useKycAttempts;
